import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_ready_for_dispatch_settings: { message: "idle" },
};

export const update_ready_for_dispatch_settings_Slice = createSlice({
 name: "update_ready_for_dispatch_settings",
 initialState,
 reducers: {
  success_update_ready_for_dispatch_settings: (state, action) => {
   state.update_ready_for_dispatch_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_ready_for_dispatch_settings: (state, action) => {
   state.update_ready_for_dispatch_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_ready_for_dispatch_settings: (state) => {
   state.update_ready_for_dispatch_settings = { status: app_consts.IDLE };
  },
  loading_update_ready_for_dispatch_settings: (state) => {
   state.update_ready_for_dispatch_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_ready_for_dispatch_settings, fail_update_ready_for_dispatch_settings, reset_update_ready_for_dispatch_settings, loading_update_ready_for_dispatch_settings } = update_ready_for_dispatch_settings_Slice.actions;

export default update_ready_for_dispatch_settings_Slice.reducer;